(() => {
  const toast = document.getElementById('pc-wa-toast');
  const help = document.querySelector('[data-pc-help]');
  if (!toast || !help) return;

  const key = 'pato_carlo_wa_aviso_v9';
  let hideTimer;
  let showTimer;
  const close = () => {
    clearTimeout(hideTimer);
    clearTimeout(showTimer);
    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
    toast.setAttribute('inert', '');
    help.setAttribute('aria-expanded', 'false');
  };
  const open = () => {
    clearTimeout(hideTimer);
    clearTimeout(showTimer);
    toast.removeAttribute('inert');
    toast.setAttribute('aria-hidden', 'false');
    toast.classList.add('is-visible');
    help.setAttribute('aria-expanded', 'true');
    hideTimer = window.setTimeout(close, 7000);
  };

  toast.querySelector('[data-pc-close]')?.addEventListener('click', close);
  help.addEventListener('click', () => {
    if (toast.classList.contains('is-visible')) close();
    else open();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && toast.classList.contains('is-visible')) close();
  });

  // Solo aparece automáticamente en la página de inicio y una vez por sesión.
  // El pequeño botón ? sigue disponible siempre, para volver a mostrar el pato.
  if (toast.dataset.home !== 'true') return;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
  } catch (_) {}
  showTimer = window.setTimeout(() => {
    if (document.visibilityState === 'visible') open();
  }, 3000);
})();
